"use strict";

exports.__esModule = true;
var _PlantTwinScreen = require("./PlantTwinScreen");
Object.keys(_PlantTwinScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PlantTwinScreen[key]) return;
  exports[key] = _PlantTwinScreen[key];
});